import { opacity } from '../../utils';
import { grayPaletteDark } from '../../themes/dark-colors';

export const drawerDarkTheme = {
  backgroundColor: grayPaletteDark[0],
  shadow: opacity(grayPaletteDark[0], 10),
};
